import { Box, BoxProps } from "@chakra-ui/react";

export function LegalComplianceIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Scales of Justice - Central Column */}
        <rect
          x="9.5"
          y="2"
          width="1"
          height="8"
          fill="currentColor"
          opacity="0.9"
        />

        {/* Scales Base */}
        <rect
          x="8"
          y="9"
          width="4"
          height="0.5"
          fill="currentColor"
          opacity="0.9"
        />

        {/* Left Scale Arm */}
        <path
          d="M10 9L5 11"
          stroke="currentColor"
          strokeWidth="1.2"
          opacity="0.9"
        />

        {/* Right Scale Arm */}
        <path
          d="M10 9L15 11"
          stroke="currentColor"
          strokeWidth="1.2"
          opacity="0.9"
        />

        {/* Left Scale Pan */}
        <ellipse
          cx="5"
          cy="11"
          rx="2.5"
          ry="0.8"
          fill="currentColor"
          opacity="0.8"
        />

        {/* Right Scale Pan */}
        <ellipse
          cx="15"
          cy="11"
          rx="2.5"
          ry="0.8"
          fill="currentColor"
          opacity="0.8"
        />

        {/* Scale Chains */}
        <path
          d="M5 11L5 13"
          stroke="currentColor"
          strokeWidth="0.8"
          opacity="0.7"
        />
        <path
          d="M15 11L15 13"
          stroke="currentColor"
          strokeWidth="0.8"
          opacity="0.7"
        />

        {/* Gavel Handle */}
        <rect
          x="9.2"
          y="13"
          width="1.6"
          height="4"
          fill="currentColor"
          opacity="0.9"
          rx="0.3"
        />

        {/* Gavel Head */}
        <rect
          x="7"
          y="12.5"
          width="6"
          height="1.5"
          fill="currentColor"
          opacity="0.95"
          rx="0.2"
        />

        {/* Legal Document - Left */}
        <rect
          x="1"
          y="4"
          width="3"
          height="4"
          fill="currentColor"
          opacity="0.3"
          rx="0.2"
        />
        <path
          d="M1.5 5H3M1.5 5.8H3M1.5 6.6H3M1.5 7.4H3"
          stroke="currentColor"
          strokeWidth="0.3"
          opacity="0.6"
        />

        {/* Legal Document - Right */}
        <rect
          x="16"
          y="4"
          width="3"
          height="4"
          fill="currentColor"
          opacity="0.3"
          rx="0.2"
        />
        <path
          d="M16.5 5H18M16.5 5.8H18M16.5 6.6H18M16.5 7.4H18"
          stroke="currentColor"
          strokeWidth="0.3"
          opacity="0.6"
        />

        {/* Justice Symbol - Small scales on documents */}
        <circle cx="2.5" cy="5.5" r="0.3" fill="currentColor" opacity="0.5" />
        <circle cx="17.5" cy="5.5" r="0.3" fill="currentColor" opacity="0.5" />
      </svg>
    </Box>
  );
}
